module.exports = __webpack_public_path__ + "img/tinder-shadow-left.be5afe4.png";